import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router'


// 创建axios实例
const service = axios.create({
  baseURL: 'https://df.faqun.cn/', // 基础URL
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 例如：添加token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    
    // 如果是 FormData，删除 Content-Type 让浏览器自动设置
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }
    
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const res = response.data
    
    // 这里可以根据后端的响应结构进行调整
    if (res.code === 0) {
      return res.data
    } 
    else {
      // 如果业务状态码不是0，说明业务逻辑有错误
      // 需要根据业务状态码进行相应处理
      if (res.code === 401) {
        // 业务层面的401，可能是token过期
        ElMessage.error('登录已过期，请重新登录')
       
        setTimeout(() => {
          localStorage.removeItem('token')  // 清除token
          router.push('/login')
        }, 1000)
        return res.data
        // router.push('/login')
      } else {
        ElMessage.error(res.message || res.msg || '请求失败')
      }
      return Promise.reject(new Error(res.message || res.msg || '请求失败'))
    }
  },
  error => {
    // 对响应错误做点什么
    console.error('响应错误:', error)
    
    let message = '网络错误'
    if (error.response) {
      switch (error.response.status) {
        case 401:
          message = '未授权，请重新登录'
          // 可以在这里处理登录过期逻辑
          break
        case 403:
          message = '拒绝访问'
          break
        case 404:
          message = '请求地址出错'
          break
        case 500:
          message = '服务器内部错误'
          break
        default:
          message = error.response.data?.message || '请求失败'
      }
    }
    
    ElMessage.error(message)
    return Promise.reject(error)
  }
)

export default service
